import React from 'react'

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  darkMode?: boolean
  buttonRef?: React.Ref<HTMLButtonElement>
  noUpperCase?: boolean
  variant?: 'primary' | 'secondary'
}

export default function Button({
  children,
  variant,
  darkMode,
  className,
  disabled,
  buttonRef,
  noUpperCase,
  ...props
}: ButtonProps) {
  return (
    <button
      ref={buttonRef}
      className={`px-4 py-1 rounded-full transition-all border font-serif ${variant === 'secondary' ? 'border-transparent bg-neutral-900/50 hover:bg-neutral-900/70' : 'border-primary hover:bg-primary-light'} ${noUpperCase ? '' : 'uppercase'} italic ${darkMode ? 'text-white' : 'text-black'} ${disabled ? 'opacity-65 pointer-events-none' : ''} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
